/**
 * Mock data for initiative cards
 */
import { mockUser } from '@/api/mockApi/userApi';
const charachterStats = {
    strength: 10,
    dexterity: 10,
    constitution: 10,
    intelligence: 10,
    wisdom: 10,
    charisma: 10,
    speed: 30,
    level: 1,
};
export let mockCards = [
    Object.assign({ id: 1, name: 'Герой', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQrzN62VAOqGXtLGMFThAOfvFBgvvVhc13AzQ&s', initiative: 15, maxHealth: 30, tempHealth: 10, health: 30, armorClass: 16, notes: 'Воин', isActive: false, createdBy: mockUser }, charachterStats),
    Object.assign({ id: 2, name: 'Гоблин', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaTMl_vlbJyh-uvDzZmhmMhVyIO5uYm4K7Qw&s', initiative: 12, maxHealth: 10, tempHealth: 0, health: 10, armorClass: 13, notes: 'Мелкий враг', isActive: false, createdBy: mockUser }, charachterStats),
    Object.assign({ id: 3, name: 'Гоблин', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSX46esgBzHmlnIWPtlcKAh7cCIauK4erzE3LDlujetdKZCBkVVK0Z41rINhZ_97HiiOjE', initiative: 11, maxHealth: 10, tempHealth: 3, health: 10, armorClass: 13, notes: 'Мелкий враг', isActive: false, createdBy: mockUser }, charachterStats),
    Object.assign({ id: 4, name: 'Гоблин', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRiQLdYN2Ttcbltq_EDc3IWtfvSLemMLO7IFg&s', initiative: 1, maxHealth: 10, tempHealth: 0, health: 10, armorClass: 13, notes: 'Мелкий враг', isActive: false, createdBy: mockUser }, charachterStats),
    Object.assign({ id: 5, name: 'Маг', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQb1sqZfY36PYutkTBiEDtN-7KeuLov3am4sA&s', initiative: 18, maxHealth: 20, tempHealth: 0, health: 20, armorClass: 12, notes: 'Заклинатель', isActive: false, createdBy: mockUser }, charachterStats),
    Object.assign({ id: 6, name: 'Маг', imageUrl: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQAnzRMKxbRhwk0ziRfwya-eb5u2Ttl2b2kzA&s', initiative: 4, maxHealth: 20, tempHealth: 0, health: 20, armorClass: 12, notes: 'Заклинатель', isActive: false, createdBy: mockUser }, charachterStats),
];
export const mockCombatMap = {
    id: 1,
    name: 'Mock Combat Map',
    characters: mockCards,
    createdBy: mockUser.id,
};
export const combatLogs = [];
export const setMockCards = (updatedCards) => {
    mockCards = [...updatedCards];
};
let nextCardId = 7;
export const getNextCardId = () => nextCardId++;
let nextCombatMapId = 1;
export const getNextCombatMapId = () => nextCombatMapId++;
